// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty[data-v-2f7b51d2] {\n  width: 100%;\n  min-height: 150px;\n  border-radius: 4px;\n  border: 1px dashed #ededed;\n  text-align: center;\n  line-height: 150px;\n  font-size: 14px;\n  color: #333;\n}\n", ""]);
// Exports
module.exports = exports;
